// Client "Give feedback" entry point. External Typeform — no backend, no modal.
// Carried over verbatim from the design prototype (Client.html FEEDBACK_URL).
export const FEEDBACK_URL = 'https://28yhv5ik85n.typeform.com/to/VnoBJXwB';

/** Open the feedback form in a new tab. `noopener` keeps the opened tab from
 *  reaching back into `window.opener`; `noreferrer` also suppresses the Referer
 *  header to the external form. */
export const openFeedback = (): void => {
  window.open(FEEDBACK_URL, '_blank', 'noopener,noreferrer');
};
